// Knowledge Library — bilingual resources, categories, and result→resource mapping

export const LIBRARY_CATEGORIES = [
  { id: 'basics', zh: '哺乳基础', en: 'Breastfeeding Basics' },
  { id: 'anatomy', zh: '乳房与泌乳原理', en: 'Breast Anatomy & Milk Production' },
  { id: 'enough', zh: '宝宝喝够了吗', en: 'Is Baby Getting Enough?' },
  { id: 'latch', zh: '亲喂与姿势', en: 'Latch & Positioning' },
  { id: 'pumping', zh: '挤奶与手挤', en: 'Pumping & Hand Expression' },
  { id: 'engorgement', zh: '涨奶/堵奶/乳腺炎', en: 'Engorgement / Clogged Duct / Mastitis' },
  { id: 'bleb', zh: '小白点与乳头护理', en: 'Milk Bleb & Nipple Care' },
  { id: 'epsom', zh: 'Epsom salt 浸泡', en: 'Epsom Salt Soaking' },
  { id: 'pump_fit', zh: '挤奶器与喇叭尺寸', en: 'Pump & Flange Fit' },
  { id: 'work', zh: '回职场与储奶', en: 'Returning to Work & Milk Storage' },
  { id: 'newborn', zh: '新生儿护理', en: 'Newborn Care' },
];

// type: 'video' | 'image_guide' | 'guide'
export const LIBRARY_RESOURCES = [
  {
    id: 'breast_anatomy',
    title_zh: '乳房构造：妈妈需要知道的基础',
    title_en: 'Breast Anatomy: Basics Mothers Should Know',
    type: 'image_guide',
    category: 'anatomy',
    desc_zh: '用简单图解认识乳头、乳晕、乳腺组织和奶流路径，帮助你理解为什么会涨奶、堵奶或乳头疼痛。',
    desc_en: 'A simple visual guide to the nipple, areola, milk-making tissue, and milk flow so mothers can understand engorgement, clogged ducts, and nipple pain better.',
    content_zh: [
      '乳房由乳腺小叶、乳管、脂肪组织和血管组成。',
      '乳头是奶流出的最后通道，乳晕是周围色素较深的皮肤。',
      '宝宝含乳时含到的应是乳晕而不仅是乳头。',
      '了解构造能帮助你判断是「整体涨」还是「局部堵」。',
    ],
    content_en: [
      'The breast is made up of lobules, milk ducts, fatty tissue, and blood vessels.',
      'The nipple is the final exit for milk; the areola is the darker skin around it.',
      'Baby should latch onto the areola, not just the nipple tip.',
      'Knowing the anatomy helps distinguish "whole-breast fullness" from a "local clog".',
    ],
  },
  {
    id: 'how_milk_is_made',
    title_zh: '泌乳原理：奶水是怎样制作的？',
    title_en: 'How Breastmilk Is Made',
    type: 'guide',
    category: 'anatomy',
    desc_zh: '了解供需原理、荷尔蒙、亲喂和挤奶频率如何影响奶量。',
    desc_en: 'Understand supply and demand, hormones, and how direct feeding or pumping frequency affects milk supply.',
    content_zh: [
      '产后泌乳由 prolactin 和 oxytocin 两个主要荷尔蒙启动。',
      '乳汁的产量取决于「移出量」，移出多 → 制造多。',
      '亲喂或挤奶间隔越长，身体收到的信号是「需要少」。',
      '稳定的 2-3 小时排奶节奏有助于维持奶量。',
    ],
    content_en: [
      'Postpartum lactation is driven mainly by prolactin and oxytocin.',
      'Supply follows demand: the more milk is removed, the more is produced.',
      'Long gaps between feeds/pumps signal the body to make less.',
      'A steady 2-3 hour milk-removal rhythm helps maintain supply.',
    ],
  },
  {
    id: 'breastmilk_vs_formula',
    title_zh: '母乳 vs 配方奶：不是比赛，是选择',
    title_en: 'Breastmilk vs Formula: A Supportive Comparison',
    type: 'guide',
    category: 'basics',
    desc_zh: '温和解释母乳和配方奶的差异，同时支持混合喂养妈妈，不制造焦虑。',
    desc_en: 'A gentle comparison between breastmilk and formula while supporting mixed feeding without guilt.',
    content_zh: [
      '母乳含有活的免疫细胞与酶，会随宝宝需求改变。',
      '配方奶提供稳定的营养，对很多家庭是合理的选择。',
      '混合喂养可以保留母乳带来的部分好处，也减轻妈妈压力。',
      '哺乳是一段旅程，不是考试。妈妈的状态比纯不纯更重要。',
    ],
    content_en: [
      'Breastmilk contains live immune cells and enzymes that adapt to baby.',
      'Formula provides consistent nutrition and is a reasonable choice for many families.',
      'Mixed feeding can retain some breastmilk benefits while reducing pressure on mom.',
      "Breastfeeding is a journey, not an exam. Mom's wellbeing matters more than 'all or nothing'.",
    ],
  },
  {
    id: 'is_baby_enough',
    title_zh: '如何确认宝宝喝够不够奶？',
    title_en: 'How to Know If Baby Is Getting Enough Milk',
    type: 'guide',
    category: 'enough',
    desc_zh: '学习观察尿布、体重、精神状态、吞咽声和亲喂后的乳房变化。',
    desc_en: "Learn how to observe wet diapers, weight gain, baby's alertness, swallowing, and breast softness after feeding.",
    content_zh: [
      '尿布：出生头几天逐日增加，1 周后每天约 6 片以上湿尿布。',
      '体重：出院后定期跟进体重曲线，不仅看一次数字。',
      '亲喂时听到「吞咽声」是好讯号。',
      '亲喂后乳房有变软，宝宝放松、安睡，也代表喝得不错。',
    ],
    content_en: [
      'Diapers: gradually increase in first days; about 6+ wet diapers/day by 1 week.',
      'Weight: follow the growth curve over time, not one single number.',
      "Hearing baby swallow during feeding is a good sign.",
      'Breast feels softer after feeding and baby relaxes/sleeps well — both reassuring signs.',
    ],
  },
  {
    id: 'latch_tummy',
    title_zh: '亲喂姿势图：Tummy to Tummy',
    title_en: 'Latch Position: Tummy to Tummy',
    type: 'image_guide',
    category: 'latch',
    desc_zh: '宝宝身体面对妈妈，不只是头转过来，帮助宝宝更容易深含乳。',
    desc_en: "Baby's whole body faces the mother, not just the head. This helps baby achieve a deeper latch.",
    content_zh: [
      '让宝宝整个身体贴着妈妈，肚子对肚子。',
      '宝宝的头、脖子和身体在同一条直线上。',
      '避免「只把头转过来」而身体偏一边。',
      '这个姿势能让宝宝更容易深含乳，减少乳头疼痛。',
    ],
    content_en: [
      "Bring baby's whole body to face the mom, tummy to tummy.",
      "Baby's head, neck, and body should be in one line.",
      "Avoid 'only turning the head' while the body faces away.",
      'This makes a deep latch easier and reduces nipple pain.',
    ],
  },
  {
    id: 'latch_nose_lip',
    title_zh: '亲喂姿势图：Nose to Nipple / Upper Lip',
    title_en: 'Latch Position: Nose to Nipple / Upper Lip',
    type: 'image_guide',
    category: 'latch',
    desc_zh: '用乳头碰宝宝鼻子或上唇，引导宝宝张大嘴再带近。',
    desc_en: "Touch baby's nose or upper lip with the nipple to encourage a wide mouth before bringing baby close.",
    content_zh: [
      '让宝宝鼻子对着乳头，不是嘴巴对着乳头。',
      '用乳头轻碰宝宝上唇，等他张大嘴。',
      '等宝宝完全张开后，把宝宝快速带近乳房。',
      '宝宝的下巴会先碰到乳房。',
    ],
    content_en: [
      "Position baby's nose (not mouth) directly opposite the nipple.",
      "Lightly brush baby's upper lip with the nipple and wait for a wide gape.",
      'When baby opens wide, bring baby quickly onto the breast.',
      "Baby's chin should touch the breast first.",
    ],
  },
  {
    id: 'how_to_hold',
    title_zh: '如何抱宝宝亲喂',
    title_en: 'How to Hold Baby for Breastfeeding',
    type: 'image_guide',
    category: 'latch',
    desc_zh: '介绍基本抱法与支撑重点，让妈妈和宝宝都更舒服。',
    desc_en: 'Basic holding positions and support points for more comfortable breastfeeding.',
    content_zh: [
      'Cradle hold（摇篮式）：经典姿势，适合大部分妈妈。',
      'Football hold（橄榄球式）：适合剖腹产或大胸部妈妈。',
      'Side-lying（侧卧式）：适合夜间哺乳或刚生完。',
      '重点：用枕头支撑妈妈手臂和宝宝身体，不要弯腰俯身去喂。',
    ],
    content_en: [
      'Cradle hold: the classic position, suitable for most mothers.',
      'Football hold: helpful for C-section moms or larger breasts.',
      'Side-lying: useful for night feeds or right after delivery.',
      "Use pillows to support mom's arm and baby's body — don't lean over.",
    ],
  },
  {
    id: 'how_to_burp',
    title_zh: '如何拍隔',
    title_en: 'How to Burp Baby',
    type: 'video',
    duration: '1 min',
    category: 'newborn',
    desc_zh: '示范常见拍隔姿势，帮助宝宝减少胀气和不适。',
    desc_en: 'Demonstrates common burping positions to help reduce gas and discomfort.',
    content_zh: [
      '把宝宝竖抱在肩膀，一只手支撑屁股。',
      '另一只手温和地拍宝宝背部中段。',
      '也可以让宝宝趴在妈妈大腿上，轻拍背部。',
      '若拍 3-5 分钟没有打嗝，可继续喂或让宝宝侧躺休息。',
    ],
    content_en: [
      'Hold baby upright over your shoulder, supporting the bottom.',
      "Gently pat the middle of baby's back with your other hand.",
      "Alternatively, lay baby tummy-down on your lap and gently pat.",
      'If no burp after 3-5 minutes, continue feeding or let baby rest on their side.',
    ],
  },
  {
    id: 'hand_expression',
    title_zh: '1 分钟手挤奶教学',
    title_en: '1-Minute Hand Expression Guide',
    type: 'video',
    duration: '1 min',
    category: 'pumping',
    desc_zh: '适合涨奶、乳晕太硬、挤奶器排不干净或需要辅助排奶时观看。',
    desc_en: 'Useful for engorgement, hard areola, poor pump drainage, or when extra milk removal support is needed.',
    content_zh: [
      '洗手。',
      '手指呈 C 形，放在乳晕外侧。',
      '轻轻向胸壁方向按压。',
      '有节奏地按压、放松、按压。',
      '不要拉乳头。目标是软化乳晕，不是硬挤干。',
    ],
    content_en: [
      'Wash hands.',
      'Form a C-shape with your fingers outside the areola.',
      'Press gently toward the chest wall.',
      'Compress and release rhythmically.',
      'Do not pull the nipple. The goal is to soften the areola, not force empty.',
    ],
  },
  {
    id: 'nipple_massage',
    title_zh: '乳头乳晕轻柔按摩',
    title_en: 'Gentle Nipple-Areola Massage',
    type: 'video',
    duration: '1 min',
    category: 'pumping',
    desc_zh: '适合泵后乳头肿胀、乳晕处奶积住、小白点后方奶流不顺的情况。',
    desc_en: 'Useful for nipple swelling after pumping, milk accumulation around areola, and milk bleb-related flow issues.',
    content_zh: [
      '指腹放在乳晕外缘。',
      '轻柔地小圈按摩。',
      '感受到肿胀位置时停留几秒。',
      '配合慢慢手挤减压。',
      '动作要轻、慢、稳。',
    ],
    content_en: [
      'Place fingertips at the outer edge of the areola.',
      'Make small, gentle circular motions.',
      'Linger a few seconds where you feel swelling.',
      'Combine with slow hand expression to relieve pressure.',
      'Movements should be soft, slow, and steady.',
    ],
  },
  {
    id: 'epsom_salt',
    title_zh: 'Epsom salt 浸泡方法',
    title_en: 'Epsom Salt Soaking Steps',
    type: 'guide',
    category: 'epsom',
    desc_zh: '学习如何安全使用 Epsom salt 浸泡乳头，并了解为什么不建议用 rock salt 或 sea salt 代替。',
    desc_en: 'Learn how to use Epsom salt soaking and why rock salt or sea salt is not the same.',
    content_zh: [
      'Epsom salt 是 magnesium sulphate，不同于 rock salt 或 sea salt。',
      '普通盐主要是 sodium chloride，作用不同。',
      'Epsom salt 常用于局部浸泡，高渗透环境有助于表面组织液移动，并有舒缓不适的效果。',
      '将温水（不烫）放入小杯，加入约 1-2 茶匙 Epsom salt，浸泡乳头约 10 分钟。',
      '若乳头有开放性伤口、明显出血、剧痛或感染迹象，请先咨询专业人员。',
    ],
    content_en: [
      'Epsom salt is magnesium sulphate, which is different from rock salt or sea salt.',
      'Regular salt is mainly sodium chloride and has a different purpose.',
      'Epsom salt is commonly used for local soaking; its hypertonic environment may support surface fluid movement and soothe discomfort.',
      'Place warm (not hot) water in a small cup with 1-2 tsp Epsom salt, then soak the nipple for about 10 minutes.',
      'If there is an open wound, active bleeding, severe pain, or signs of infection, please consult a professional first.',
    ],
  },
  {
    id: 'manage_early_engorgement',
    title_zh: '如何处理生理性涨奶',
    title_en: 'How to Manage Early Engorgement',
    type: 'guide',
    category: 'engorgement',
    desc_zh: '了解产后初期涨奶为什么发生，以及如何通过规律移出乳汁、手挤和冷敷缓解。',
    desc_en: 'Understand why early engorgement happens and how regular milk removal, hand expression, and cold compress may help.',
    content_zh: [
      '产后 3-5 天，乳汁、血液和组织液一起增加，乳房会很胀。',
      '每 2-3 小时让宝宝吸或挤奶一次。',
      '若乳晕太硬，先轻柔手挤到比较软再让宝宝含。',
      '挤奶后冷敷 10-15 分钟。',
      '不需要大力推按，避免组织损伤。',
    ],
    content_en: [
      'Days 3-5 postpartum: milk, blood, and tissue fluid increase together, making breasts feel very full.',
      'Remove milk every 2-3 hours via latch or pump.',
      'If the areola is hard, gently hand express until softer before latching.',
      'Cold compress for 10-15 minutes after milk removal.',
      'Avoid forceful pushing — this can injure tissue.',
    ],
  },
  {
    id: 'manage_clogged_duct',
    title_zh: '如何处理堵奶',
    title_en: 'How to Manage a Clogged Duct',
    type: 'guide',
    category: 'engorgement',
    desc_zh: '学习堵奶时要观察什么、可以先做什么、什么时候需要预约或看医生。',
    desc_en: 'Learn what to observe, what to do first, and when to book support or seek medical care.',
    content_zh: [
      '观察硬块位置、大小、按压痛、皮肤红/热。',
      '继续亲喂或挤奶，优先让宝宝吸不舒服那边。',
      '不要为了「通掉」过度按摩或挤到乳头受伤。',
      '24 小时内观察硬块是否变小。',
      '若出现发烧、明显红肿热痛、奶量骤降，请尽快预约专业协助。',
    ],
    content_en: [
      'Observe lump location, size, tenderness, and skin redness/heat.',
      'Continue breastfeeding or pumping — start with the uncomfortable side.',
      "Don't over-massage or pump until the nipple is injured.",
      'Watch over 24 hours to see whether the lump shrinks.',
      'If fever, marked redness/heat/pain, or sudden supply drop occurs, seek professional help quickly.',
    ],
  },
  {
    id: 'mastitis_when_doctor',
    title_zh: '乳腺炎风险：什么时候要看医生？',
    title_en: 'Mastitis Risk: When to See a Doctor',
    type: 'guide',
    category: 'engorgement',
    desc_zh: '认识发烧、红肿热痛、全身酸痛等 red flags，避免延误处理。',
    desc_en: 'Recognise red flags such as fever, redness, heat, swelling, pain, and body ache.',
    content_zh: [
      '体温 38°C 或以上 → 看医生',
      '红色范围扩大 → 看医生',
      '剧烈疼痛或感觉非常不适 → 看医生',
      '发烧超过 24 小时 → 看医生',
      '在等待就医期间，继续保持乳汁移出、休息、补水。',
    ],
    content_en: [
      'Fever 38°C or above → see a doctor',
      'Red area is spreading → see a doctor',
      'Severe pain or feeling very unwell → see a doctor',
      'Fever lasting over 24 hours → see a doctor',
      'While waiting for medical care, keep milk moving, rest, and stay hydrated.',
    ],
  },
  {
    id: 'milk_bleb_care',
    title_zh: '小白点 / Milk Bleb 处理重点',
    title_en: 'Milk Bleb Care Guide',
    type: 'guide',
    category: 'bleb',
    desc_zh: '了解小白点可能原因、浸泡、乳头乳晕护理和何时需要顾问协助。',
    desc_en: 'Understand possible causes, soaking, nipple-areola care, and when consultant support may be needed.',
    content_zh: [
      '小白点常和浅含乳、强吸力、喇叭尺寸不合、堵奶有关。',
      '可以配合 Epsom salt 温水浸泡约 10 分钟。',
      '继续亲喂或挤奶但减少刺激（降低吸力、调整 flange）。',
      '若白点后方有硬块、奶量明显下降，建议预约顾问。',
      '不要自行用针戳破，避免感染。',
    ],
    content_en: [
      'Milk blebs are often linked to shallow latch, strong suction, wrong flange size, or recent clog.',
      'Pair with Epsom salt warm soaking for about 10 minutes.',
      'Continue breastfeeding/pumping but reduce irritation (lower suction, adjust flange).',
      'If a lump sits behind the bleb or output drops, book a consultant.',
      "Don't pop with a needle yourself — risk of infection.",
    ],
  },
  {
    id: 'pump_flange_fit',
    title_zh: '挤奶器喇叭尺寸检查',
    title_en: 'Pump Flange Fit Check',
    type: 'image_guide',
    category: 'pump_fit',
    desc_zh: '了解喇叭太大、太小或比较合适时乳头和乳晕会有什么表现。',
    desc_en: 'Learn how the nipple and areola may look when the flange is too big, too small, or better fitted.',
    content_zh: [
      '太小：乳头摩擦喇叭壁，泵后变红或痛。',
      '太大：乳晕被过度拉入隧道，奶量低。',
      '合适：乳头自由移动，乳晕几乎不进入隧道。',
      '左右乳头大小可能不同，要分开测量。',
      '产后初期乳头可能肿胀，过几周再复测会更准。',
    ],
    content_en: [
      'Too small: nipple rubs the flange wall, red/painful after pumping.',
      'Too big: too much areola pulled into the tunnel, low output.',
      'Better fit: nipple moves freely, minimal areola inside the tunnel.',
      'Left and right nipples may differ — measure both.',
      'Early postpartum nipples may be swollen; re-measure a few weeks later.',
    ],
  },
  {
    id: 'return_to_work',
    title_zh: '回职场挤奶准备',
    title_en: 'Returning to Work Pumping Plan',
    type: 'guide',
    category: 'work',
    desc_zh: '帮助妈妈提前安排挤奶频率、储奶、泵奶器材和工作日节奏。',
    desc_en: 'Plan pumping frequency, milk storage, pump equipment, and workday routine before returning to work.',
    content_zh: [
      '回职场前 2-3 周开始练习挤奶并储奶。',
      '工作日尽量保持 3-4 小时一次挤奶节奏。',
      '准备 2 套泵奶配件，可以一边用一边洗。',
      '储奶袋标日期，先进先出。',
      '冷藏 4 天内使用，冷冻最长 6 个月。',
    ],
    content_en: [
      'Start practising and storing milk 2-3 weeks before returning to work.',
      'On workdays, aim for a pumping session every 3-4 hours.',
      'Have 2 sets of pump parts so one can be washing while the other is in use.',
      'Label storage bags with date — first in, first out.',
      'Refrigerator: use within 4 days. Freezer: up to ~6 months.',
    ],
  },
];

// Map module result → recommended library resource IDs (related resources)
export const MODULE_LIBRARY_MAP = {
  A: ['hand_expression', 'manage_early_engorgement'],
  B: ['manage_clogged_duct', 'nipple_massage'],
  C: ['mastitis_when_doctor', 'manage_clogged_duct'],
  D: ['latch_tummy', 'latch_nose_lip', 'hand_expression'],
  E: ['epsom_salt', 'milk_bleb_care'],
  F: ['pump_flange_fit'],
  G: ['is_baby_enough', 'how_milk_is_made'],
  H: ['latch_tummy', 'latch_nose_lip', 'how_to_hold'],
};

export const FEATURED_RESOURCES = ['hand_expression', 'epsom_salt', 'is_baby_enough', 'pump_flange_fit'];
